(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalog40-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('catalog40-review-slider')) {
  customElements.define('catalog40-review-slider', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const rail = this.querySelector('.nh-ugc21__row');
      const cards = [...rail.children]; if (!cards.length) return;
      const previous = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      const refresh = () => {
        const step = cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : rail.clientWidth;
        this.querySelector('[data-review-position]').textContent = `${Math.round(rail.scrollLeft / step) + 1} / ${cards.length}`;
        previous.disabled = rail.scrollLeft < 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      };
      const move = direction => rail.scrollBy({left: direction * (cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : rail.clientWidth), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      previous.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      rail.addEventListener('scroll', refresh, {signal, passive:true});
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.nh-ugc21__card');
        if (card && this.contains(card)) rail.scrollTo({left:card.offsetLeft - cards[0].offsetLeft, behavior:'auto'});
      }, {signal});
      refresh();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jacket-nineheat-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jacket-review-slider')) {
  customElements.define('jacket-review-slider', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const rail = this.querySelector('.nh-ugc21__row');
      const cards = [...rail.children];
      const previous = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      const refresh = () => {
        const step = cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : rail.clientWidth;
        this.querySelector('[data-review-position]').textContent = `${Math.round(rail.scrollLeft / step) + 1} / ${cards.length}`;
        previous.disabled = rail.scrollLeft < 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      };
      const move = direction => rail.scrollBy({left: direction * (cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : rail.clientWidth), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      previous.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      rail.addEventListener('scroll', refresh, {signal, passive:true});
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.nh-ugc21__card');
        if (card && this.contains(card)) rail.scrollTo({left:card.offsetLeft - cards[0].offsetLeft, behavior:'auto'});
      }, {signal});
      refresh();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-comforter-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('catalog40-review-slider')) {
  customElements.define('catalog40-review-slider', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const rail = this.querySelector('.nh-ugc21__row');
      const cards = [...rail.children]; if (!cards.length) return;
      const previous = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      const refresh = () => {
        const step = cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : rail.clientWidth;
        this.querySelector('[data-review-position]').textContent = `${Math.round(rail.scrollLeft / step) + 1} / ${cards.length}`;
        previous.disabled = rail.scrollLeft < 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      };
      const move = direction => rail.scrollBy({left: direction * (cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : rail.clientWidth), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      previous.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      rail.addEventListener('scroll', refresh, {signal, passive:true});
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.nh-ugc21__card');
        if (card && this.contains(card)) rail.scrollTo({left:card.offsetLeft - cards[0].offsetLeft, behavior:'auto'});
      }, {signal});
      refresh();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plaid-material-value"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('plaid-material-value'))customElements.define('plaid-material-value',class extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();this.sources=JSON.parse(this.querySelector('[data-pmv-sources]').textContent);this.update=(color)=>{const source=this.sources.find(item=>item.color===color);if(!source)return;this.dataset.first=String(source.first);this.querySelectorAll('[data-pmv-image]').forEach(img=>{img.src=source[img.dataset.pmvImage];img.alt=(document.documentElement.lang.startsWith('ja')?'素材の質感 — ':document.documentElement.lang.startsWith('it')?'Dettaglio del materiale — ':document.documentElement.lang.startsWith('pl')?'Detal materiału — ':'Materialansicht — ')+source.label;});};document.addEventListener('plaid:variant-change',event=>this.update(event.detail?.color),{signal:this.abort.signal});const selected=document.querySelector('[data-plaid-color][aria-pressed="true"]')?.dataset.plaidColor;if(selected)this.update(selected);}
 disconnectedCallback(){this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();
})();
